export default __webpack_public_path__ + "static/media/venvlp.7bd1c8d6.svg";